import React from 'react'
import { Row, Col, FormControl, FormGroup } from 'react-bootstrap'
import Avatar from './avatar'
import './index.styl'

class Component extends React.Component {
  constructor (props) {
    super(props)
    this.blur = this.blur.bind(this);
    this.focus = this.focus.bind(this);
    this.state = {
      focussed: false,
    }
  }

  triggerLogout () {
    const {actions} = this.props
    actions.loginLoggedOut()
    actions.logout()
  }

  triggerLogin () {
    const {actions} = this.props
    actions.loginInProgress()
    actions.login()
  }

  focus() {
    this.setState({
      focussed: true
    })
  }

  blur() {
    this.setState({
      focussed: false
    })
  }

  render () {
    const { auth, me, actions, route, type, project } = this.props

    if (auth.isLoggedIn === false || me === null) {
      return (
        <nav id="navbar">
          <section className="container">
            <Row>
              <Col xs={12} sm={3}>
                <a className="brand">iLoyalty</a>
              </Col>

              <Col xs={12} sm={6}></Col>
              <Col xs={12} sm={3}>
                <div className="controls-container">
                  <a className="btn btn-primary" onClick={() => {this.triggerLogin()}}>Sign in</a>
                </div>
              </Col>
            </Row>
          </section>
        </nav>
      )
    }

    return (
      <nav id="navbar">
        <section className="container">
          <Row>
            <Col xs={12} sm={9}>
              <a className="brand">iLoyalty</a>
              <a className="project">Export Tool</a>
            </Col>
            <Col xs={12} sm={3}>
              <Row>
                <Col xs={6} />
                <Col xs={3}>
                  <div className="controls-container">
                    <a className="logout-icon" onClick={() => {this.triggerLogout()}}></a>
                  </div>
                </Col>
                <Col xs={3}>
                  <div className="controls-container">
                    <Avatar email={me.email} size="small" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <nav className="main-nav">
                <ul>
                  <li className={route === '/' ? 'active' : ''}><a onClick={() => { actions.push('/') }}>1. Soort export</a></li>
                  <li className={route === '/projects' ? 'active' : ''}><a onClick={() => { actions.push('/projects') }}>2a. Project</a></li>
                  <li className={route === '/segments' ? 'active' : ''}><a className={type !== 'segments' ? 'disabled' : ''} onClick={() => { actions.push('/segments') }}>2b. Segment</a></li>
                  <li className={route === '/headers' ? 'active' : ''}><a className={(type === null || project === null) ? 'disabled' : ''} onClick={() => { actions.push('/headers') }}>3. Kolommen</a></li>
                  <li className={route === '/saved-reports' ? 'move-right active' : 'move-right'}><a onClick={() => { actions.push('/saved-reports') }}>Rapportages</a></li>
                </ul>
              </nav>
            </Col>
          </Row>
        </section>
        <div className={this.state.focussed ? "overlay" : ""}>
      </div>
      </nav>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Navbar/index.js